"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.boxSpacing = exports.lighten = exports.darken = exports.fade = exports.emphasize = exports.getLuminance = exports.getContrastRatio = exports.rgbToHex = exports.spacingValues = exports.createPaddingClassNames = exports.paddingSpacing = exports.createMarginClassNames = exports.marginSpacing = void 0;

var utilities_1 = require("./utilities");

Object.defineProperty(exports, "spacingValues", {
  enumerable: true,
  get: function get() {
    return utilities_1.spacingValues;
  }
});

var padding_1 = require("./padding");

Object.defineProperty(exports, "paddingSpacing", {
  enumerable: true,
  get: function get() {
    return padding_1.paddingSpacing;
  }
});
Object.defineProperty(exports, "createPaddingClassNames", {
  enumerable: true,
  get: function get() {
    return padding_1.createPaddingClassNames;
  }
});

var margin_1 = require("./margin");

Object.defineProperty(exports, "marginSpacing", {
  enumerable: true,
  get: function get() {
    return margin_1.marginSpacing;
  }
});
Object.defineProperty(exports, "createMarginClassNames", {
  enumerable: true,
  get: function get() {
    return margin_1.createMarginClassNames;
  }
});

var colorManipulator_1 = require("./colorManipulator");

Object.defineProperty(exports, "rgbToHex", {
  enumerable: true,
  get: function get() {
    return colorManipulator_1.rgbToHex;
  }
});
Object.defineProperty(exports, "getContrastRatio", {
  enumerable: true,
  get: function get() {
    return colorManipulator_1.getContrastRatio;
  }
});
Object.defineProperty(exports, "getLuminance", {
  enumerable: true,
  get: function get() {
    return colorManipulator_1.getLuminance;
  }
});
Object.defineProperty(exports, "emphasize", {
  enumerable: true,
  get: function get() {
    return colorManipulator_1.emphasize;
  }
});
Object.defineProperty(exports, "fade", {
  enumerable: true,
  get: function get() {
    return colorManipulator_1.fade;
  }
});
Object.defineProperty(exports, "darken", {
  enumerable: true,
  get: function get() {
    return colorManipulator_1.darken;
  }
});
Object.defineProperty(exports, "lighten", {
  enumerable: true,
  get: function get() {
    return colorManipulator_1.lighten;
  }
});
exports.boxSpacing = Object.assign(Object.assign({}, margin_1.marginSpacing), padding_1.paddingSpacing);